<template>
    <section>
        <b-overlay :show="loading" rounded="sm">
           <div class="card">
				<div class="card-header p-2">
					<div>
						<small class="float-left">Rides:{{totalRides}}</small>
					</div>
				</div>
				<span class="text-center m-5" v-if="empty">{{$t('global.ajaxTable.noRecordsFound')}}</span>
				<div class="card-body p-1" v-else>
					<chart :options="chartOptions" ref="chart"></chart>
				</div>
			</div>
        </b-overlay>
    </section>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
    exportingInit(Highcharts)

    export default {
        name: "RidePerStatus",
        components:{Chart},
        props: {
            filters: {
                type : Object,
                required: true
            },
            triggerSearch:{
                type : Number,
                required: true
            }
        },
        data(){
			const vueContext = this;
			let seriesExample=[{
				name: 'Share',
				data: []
			}]

			let schemeOptions = {
				chart:{
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					type:'pie'
				},
				title: {
					text: this.$t('dashboard.myRides')
				},
				tooltip: {
					enabled:false
				},
				yAxis: {
					title: {
						text: '# Rides'
					}
				},
				exporting:{
					buttons:{
						menuItems:["viewFullscreen"]
					}
				},
				xAxis:{
					type: 'category',
					categories:[],
					max:null,
				},
				series: seriesExample,
				plotOptions: {
					series: {
						dataLabels: {
							enabled: true,
							formatter:function(){
								let keySearch  = "transportServiceStatus."+this.key;
								let statusName = vueContext.$t(keySearch)
								if(statusName  == keySearch ){
									statusName = this.key
								}
								return statusName +": "+this.y+"%"
							}
						},
					}
				}
			}

            return {
                totalRides:0,
                loading:false,
                exporting: {
                    enabled: true
                },
                codeReport : "rides-per-status-pie",
                chartOptionsModel: {...schemeOptions}
            }
        },
        methods:{
            fetchDataChart(){
                this.loading=true;
                this.$root.api.get(`/dashboard/charts/${this.codeReport}`,{params: {filters:this.filters}}).then((res) => {
                    this.totalRides = res.data.totalRides;
					setTimeout(()=>{
						this.chartOptionsModel.series               = res.data.series;
						this.chartOptionsModel.xAxis.categories     = res.data.categories;
					},0)

                })
				.catch(this.$root.handleRequestError)
				.finally(()=>{
					this.loading=false
				})
            }
        },
        watch:{
            triggerSearch(){//este valor es reactivo, el padre decide en que momento se dispara la busqueda
                this.fetchDataChart();
            }
        },
        mounted() {
            if(this.triggerSearch>0){
                this.fetchDataChart();
            }
        },
		computed:{
			chartOptions(){
				return this.chartOptionsModel;
			},
			empty(){
				return !(this.totalRides>0)
			}
		}
    }
</script>

<style scoped>

</style>
